
import EditableLable from "@components/miscellany/editable_label/editable_label"
import ToggleButton from "@components/miscellany/toggle_button/toggle_button"
import store from '../../../store'
import ReferenceValues from "./reference_values/reference_values"
import Statistics from "./statistics/statistics"
import locale from '@packs/locale/locale'
import CollapseCard from "@components/miscellany/collapse/collapse_card"
import SelectComponent from "./select_component/select_component"
import PluStationsComponent from "./plu_stations_component/plu_stations_component"
import PluConfigComponent from "./plu_config_component/plu_config_component"
import StationsCounter from "./stations_counter/stations_counter"
import('./list_item.css')
export default function ListItem(opts = {}){
    let chart_name = opts.chart_name
    let chart_old_name = opts.chart_old_name
    let chart_id = opts.chart_id
    BaseConstructor.call(this)
    let elements = {}
    let chart
    let editableLabelStations, editableLabelName, toggleButtonChevron, collapseSeries, stationsCounter, toggleRemoveChart
    let context = this
    let showing_config = false
    this.generate = () =>{
        chart = store.getChart(chart_old_name)
        elements.container = this.createElement('div', 'list-item-wrapper')
        elements.list_item_title = this.createElement('div', 'list-item-title-container')
        elements.list_item_config = this.createElement('div', 'list-item-config-container pretty-scrollbar', '')
        // elements.series_options = this.createElement('div', 'list-item-series-container', '<div>Séries</div>')
        
        // elements.list_item_statistics = this.createElement('div', 'list-item-statistics-container')
        elements.name = this.createElement('div', 'list-item-name')
        elements.qtd_stations = this.createElement('div', 'list-item-qtd-stations')
        elements.chevron = this.createElement('div', '','')
        
        $(elements.list_item_title).append(elements.name,elements.qtd_stations)

        // $(elements.container).append(elements.list_item_title, elements.list_item_config, elements.list_item_statistics)


        let collapse = new CollapseCard(
            {title_options:{text:elements.list_item_title, icon_options:{}, additional_content:{position: 'right', content:titleAdditionalContainer()}}, 
            content_options:{content: elements.list_item_config}
        })

        $(elements.container).append(collapse.generate())

        //construindo nome da view
        this.buildTitle()

        //construindo contador de postos
        this.buildStationCounter()

        //construindo seletor de postos da view
        this.buildStationsSelect()

        //construindo controles de configurações da view
        this.buildConfigOptions()
        
        //construindo controle de exibição de estatisticas
        // this.buiildStatisticsOptions()

        store.subscribe('chart_nested_prop_update', data=>{
            // console.log(data);
            if(data.chart_name == chart_old_name && data.prop_path == 'stations_list.plu.ids'){
                this.buildConfigOptions()
            }
        })

        store.subscribe('chart_destroyed', name=>{
            if(chart_old_name == name){
                this.destroy()
            }
        })
        

        //events handler
        eventsHandler()
    }

    this.buildStationCounter = _ =>{
        stationsCounter = new StationsCounter({container: elements.qtd_stations, chart_name:chart_old_name})
        stationsCounter.generate()
    }

    this.buildStationsSelect = _ => {
        elements.stations_container = this.createElement('div')
        elements.stations_select_wrapper = this.createElement('div')
        elements.stations_plu_select_wrapper = this.createElement('div')

        let pluStationsComponent = new PluStationsComponent({container: elements.stations_plu_select_wrapper, chart_name: chart_old_name})
        pluStationsComponent.generate()

        $(elements.stations_container).append(elements.stations_select_wrapper,elements.stations_plu_select_wrapper)

        if(!editableLabelStations){
            editableLabelStations = new EditableLable({text: 'Nenhum posto adicionado'})
        }
        if(chart.stations_list && chart.stations_list.length > 0){
            editableLabelStations.setText(chart.stations_list)
        }
        // $(elements.stations_select_wrapper).html(editableLabelStations.getElement())

        let select_component = new SelectComponent({container: elements.stations_select_wrapper, chart_name: chart_old_name})
        select_component.generate('station_flu')

        let collapse = new CollapseCard(
            {title_options:{text:'GERAL', icon_options:{}, customClass: 'list-item-stations-title-wrapper'}, 
            content_options:{content: elements.stations_container}
        })

        $(elements.list_item_config).append(collapse.generate())

        // $(elements.list_item_config).append(groupControl.getElement())
    }

    this.reload = (chart_name) =>{
        chart = store.getChart(chart_name)
    }

    this.buildTitle = () =>{
        editableLabelName = new EditableLable({text: chart.chart_name})
        $(elements.name).html(editableLabelName.getElement())

        toggleButtonChevron = new ToggleButton({container: elements.chevron,states:[
            {title: '<i class="fas fa-chevron-down"></i>', classList: 'expand-chart-button', active: true},
            {title: '<i class="fas fa-chevron-up"></i>', classList: 'expand-chart-button', active: false}
        ]})
        toggleButtonChevron.generate()

        toggleButtonChevron.on('click', () =>{
            showing_config = !showing_config
            $(elements.list_item_config).toggleClass('show', showing_config)
            // updateConfigContainerSize()
        })
        



    }

    this.getElement = _ =>{
        return elements.container
    }

    this.buildConfigOptions = _ =>{
        let content = context.createElement('div')

        if(!collapseSeries){
            collapseSeries = new CollapseCard(
                {title_options:{text:'SÉRIES', customClass:'list-item-series-title-wrapper', icon_options:{}}, 
                content_options:{content: content, customClass:'p-0'}
            })
            $(elements.list_item_config).append(collapseSeries.generate())
        } else {
            collapseSeries.setContent(content)
        }
        
        // collapse.setContent(elements.controls_container)

        

        let plu_ids = store.getChartNestedProp(chart_old_name, 'stations_list.plu.ids') || []
        let axis = ["level", "flow"]
        
        axis.forEach(axis_name=>{
            let axis = this.createElement('div', 'axis-config-container')
            let axis_title = this.createElement('div', 'axis-config-title-container', buildTitle(axis_name))
            let axis_config = this.createElement('div', 'axis-config')

            $(axis).append(axis_title, axis_config)
            
            //container para configurações de valor de referência e estatisticas
            let reference_values_el = this.createElement('div', 'reference_values_container')
            
            //inicializando componente dos valores de referencia
            let referenceValuesComponent = new ReferenceValues({container:reference_values_el, chart_name:chart_old_name, axis_name:axis_name})

            //gerando formulario de valores de referencia
            referenceValuesComponent.generate()

            //adicionando componente ao container
            $(axis_config).append(reference_values_el)

            $(content).append(axis)

            referenceValuesComponent.on('reference-item-handled', () =>{
                // updateConfigContainerSize()
            })

            //atualizar valores do chart de acordo com os valores do component de control de valores de ref.
            referenceValuesComponent.on('input:change', obj=>{
                // console.log(chart_name);
                let series = store.getChartProp(chart_old_name, 'series') || {}
                series[axis_name] ??= {}
                series[axis_name]['reference_values'] ??= {}
                series[axis_name]['reference_values']['fields'] ??= {}
                series[axis_name]['reference_values']['fields'][obj.option] ??= {}
                series[axis_name]['reference_values']['fields'][obj.option]['options'] ??= {}
                series[axis_name]['reference_values']['fields'][obj.option]['options'][obj.input_name] = obj.value
                // series[obj.option] = reference_values[obj.option] || {}
                // series[obj.option][obj.input_name] = obj.value
                store.setChartProp(chart_old_name, 'series', series)
            })
        })

        if(plu_ids.length > 0){
            //adicionar configurações de eixo PLU
            let axis = this.createElement('div', 'axis-config-container')
            let axis_title = this.createElement('div', 'axis-config-title-container', buildTitle('rain'))
            let axis_config = this.createElement('div', 'axis-config')

            let plu_config = this.createElement('div', '')

            let pluConfigComponent = new PluConfigComponent({container: plu_config, chart_name: chart_old_name})
            pluConfigComponent.generate()

            $(axis_config).append(plu_config)

            $(axis).append(axis_title, axis_config)

            $(content).append(axis)
        }

        // $(elements.list_item_config).append(groupControl.getElement())
        
    }

    this.destroy = _ =>{
        this.getElement().remove()
    }

    function titleAdditionalContainer(){
        let el = context.createElement('div')
        toggleRemoveChart = new ToggleButton({container:el, custom_class: 'control-button control-button-remove', states:[
            { title: '<i class="fas fa-times"></i>', active: true , id:'destroy'},
            { title: 'APAGANDO', active: false, id: ''}
        ]})
        toggleRemoveChart.generate()

        toggleRemoveChart.on('click', states=>{
            if(states.fromState.id == 'destroy'){
                toggleRemoveChart.disabled(true)
                removeListItem()
            }
        })
        
        return el
    }

    function removeListItem(){
        store.removeChart(chart_old_name)
    }

    function buildTitle(axis_name){
        let show = store.getChartNestedProp(chart_old_name, `series.${axis_name}.options.show`) || 'true'
        let container = context.createElement('div')
        $(container).css({
            'display': 'flex',
            'gap': '5px',
            'align-items': 'center'
        })
        let el = context.createElement('div')
        let name = locale.t(axis_name).toUpperCase()

        show = show === 'true' //convertendo pra Boolean
        
        let toggleButton = new ToggleButton({
            container: el,
            custom_class: 'control-button control-button-visibility',
            states: [
                {title: '<i class="fas fa-eye"></i>', active: Boolean(show), id:'show', classList: 'active'},
                {title: '<i class="fa fa-eye-slash"></i>', active: !Boolean(show), id:'hide', classList: ''}
                // {title: 'Exibir', active: Boolean(show), id:'show', classList: 'active'},
                // {title: 'Exibir', active: !Boolean(show), id:'hide', classList: ''}
            ]
        })

        toggleButton.generate()

        toggleButton.on('click', data =>{
            store.setChartNestedProp(chart_old_name, `series.${axis_name}.options.show`, data.toState.id == 'show')
        })

        $(container).append(name, el)
        return container
    }

    this.buiildStatisticsOptions = _ =>{
        let statistics_el = this.createElement('div', '', 'Estatisticas')

        let statistisComponent = new Statistics({container:statistics_el, chart_name:chart_old_name})

        statistisComponent.generate()

        $(elements.list_item_config).append(statistics_el)
    }

    function eventsHandler(){
        editableLabelName.on('value-updated', data=>{
            let new_value = data.current
            store.setChartProp(chart_old_name, 'chart_name', new_value)
            chart_name = new_value
        })

        editableLabelStations.on('value-updated', data=>{
            let new_value = data.current
            store.setChartProp(chart_old_name, 'stations_list', new_value)
        })

        

        
    }
}

ListItem.prototype = Object.create(BaseConstructor.prototype)